import React from 'react';
import { Sparkles, Wrench, ShieldCheck } from 'lucide-react';
import { motion } from 'framer-motion';
import { useLanguage } from '../i18n/LanguageContext';
export function MechanismSection() {
  const {
    t
  } = useLanguage();
  const capas = [{
    num: '01',
    title: t('mechanism.c1Title'),
    icon: <Sparkles className="w-8 h-8 text-brand-gold" data-id="element-241" />,
    desc: t('mechanism.c1Desc')
  }, {
    num: '02',
    title: t('mechanism.c2Title'),
    icon: <Wrench className="w-8 h-8 text-brand-gold" data-id="element-242" />,
    desc: t('mechanism.c2Desc')
  }, {
    num: '03',
    title: t('mechanism.c3Title'),
    icon: <ShieldCheck className="w-8 h-8 text-brand-gold" data-id="element-243" />,
    desc: t('mechanism.c3Desc')
  }];
  return <section id="sistema" className="py-24 lg:py-32 bg-brand-black relative overflow-hidden" data-id="element-244">
      {/* Background accents */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-brand-dark to-transparent opacity-50 pointer-events-none" data-id="element-245"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-246">
        <div className="text-center max-w-4xl mx-auto mb-20" data-id="element-247">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-block border border-brand-gold/30 bg-brand-gold/10 text-brand-gold px-4 py-1.5 rounded-full text-sm font-bold tracking-widest uppercase mb-6" data-id="element-248">
            {t('mechanism.badge')}
          </motion.div>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-3xl md:text-5xl font-serif font-bold text-white mb-6 leading-tight" data-id="element-249">
            {t('mechanism.title')}
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-lg md:text-xl text-white/70 leading-relaxed" data-id="element-250">
            {t('mechanism.desc')}
          </motion.p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-251">
          {capas.map((capa, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2 + 0.3,
          duration: 0.6
        }} whileHover={{
          y: -10
        }} className="bg-brand-dark border border-white/10 rounded-2xl p-8 md:p-10 relative group transition-all duration-300 hover:border-brand-gold/50 hover:shadow-[0_10px_40px_rgba(212,164,55,0.1)]" data-id="element-252">
              {/* Large background number */}
              <div className="absolute top-4 right-6 text-7xl font-serif font-bold text-white/5 group-hover:text-brand-gold/10 transition-colors pointer-events-none" data-id="element-253">
                {capa.num}
              </div>

              <div className="bg-brand-black border border-white/5 w-16 h-16 rounded-xl flex items-center justify-center mb-8 relative z-10 group-hover:scale-110 transition-transform duration-300" data-id="element-254">
                {capa.icon}
              </div>

              <h3 className="text-xl font-bold text-white mb-2 relative z-10" data-id="element-255">
                CAPA {capa.num}
              </h3>
              <h4 className="text-brand-gold font-serif text-2xl font-bold mb-6 relative z-10" data-id="element-256">
                {capa.title}
              </h4>

              <p className="text-white/70 leading-relaxed relative z-10" data-id="element-257">
                {capa.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}